import Menu from './menu';

export default class MenuDesktop extends Menu {
	constructor(...args) {
		super(...args);

		this._initDom();
		this._currentScroll = null;
		this._height = this.dom.component.offsetHeight;
		this._isHover = false;
        this._heightMenuDefault = this.dom.menu.offsetHeight;
	}

	init() {
		window.onscroll = () => {
			if (this._getScroll() > this._height) {
                this.dom.menu.classList.add('overlay');
                this.dom.menu.classList.add('scroll');
            } else {
				this.dom.menu.classList.remove('overlay');
				this.dom.menu.classList.remove('scroll');
            }
		};

		for (let i = 0; i < this.dom.langItem.length; i++) {
			const el = this.dom.langItem[i];
			el.addEventListener('click', (e)=>{
				e.preventDefault();
				this.dom.langs.classList.add('shown');

				let url = el.getAttribute('href');
				if (!el.classList.contains('active'))
					window.location = url;
			});
			
		}
	}

    bind() {
	    for( let i = 0, j = this.dom.targetHover.length; i < j; i++ ) {
	        let target = this.dom.targetHover[i];
	        target.addEventListener( 'mouseenter', this._enterMenu.bind(this) );
        }

        this.dom.menu.addEventListener( 'mouseleave', this._leaveMenu.bind(this) );
    }

	_initDom() {
		this.dom.menu = this.dom.component.querySelector('.menu-head');
		this.dom.langs = this.dom.component.querySelector('.langs');
		this.dom.langItem = this.dom.langs.querySelectorAll('.link-item a');
		this.dom.targetHover = this.dom.component.querySelectorAll('.js-target-hover');
	}

	_getScroll() {
		this._currentScroll = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
		return this._currentScroll;
	}

    _enterMenu( event ) {

	    // Recalculate the height of the menu if there is a submenu
	    let target = event.currentTarget;

	    if( target.classList.contains('has-children') ) {
	        let menuChild = target.querySelector('.js-menu-child');
	        let menuChildHeight = menuChild.offsetHeight;
	        let itemChild = target.querySelectorAll('.js-item-child');
	        let itemChildHeight = itemChild[0].offsetHeight;

	        let heightChildren = menuChildHeight -  itemChildHeight - 10;

            this.dom.menu.style.height = (this._heightMenuDefault + heightChildren) + 'px';
        } else {
            this.dom.menu.style.height = this._heightMenuDefault + 'px';
        }


	    if( this._isHover == false ) {
            this._isHover = true;

            // If the menu does not already contain the class "overlay"
            if( !this.dom.menu.classList.contains('overlay') ) {
                this.dom.menu.classList.add('overlay')
            }
        }
    }

    _leaveMenu( event ) {

        if( !this.dom.menu.classList.contains('scroll') ) {
            this.dom.menu.classList.remove('overlay');
        }
        this._isHover = false;
        this.dom.menu.style.height = this._heightMenuDefault + 'px';
    }

	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/menu/menu.desktop.js